import "./Button.css";

import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import classNames from "classnames";

export default class Button extends Component {
  static propTypes = {
    text: PropTypes.string
  };

  render() {
    const {
      text,
      className,
      onClick,
      disabled,
      standard,
      success,
      login,
      info,
      secondary,
      big,
      small,
      border,
      dots
    } = this.props;

    // apply styles
    let cn = {
      "button--border": border,
      standard: standard,
      success: success,
      login: login,
      info: info,
      secondary: secondary,
      big: big,
      small: small,
      dots: dots
    };
    cn[className] = className;

    const onClickFunction = onClick || function() {};

    return (
      <button
        className={classNames(cn)}
        onClick={onClickFunction}
        disabled={disabled || false}
      >
        <span>{text}</span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/Button.react.js